<template>
  <div>



 <el-table :data="DataList" stripe style="width: 100%" :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center',background:'#F5F7FA'}"
      :row-style="{background:'#ffffff'}">
      <el-table-column label="序号"  width="150px">
        <template slot-scope="scope">
          {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="itemNum" label="项目编号">
      </el-table-column>
      <el-table-column prop="itemName" label="项目名称">
      </el-table-column>
      <el-table-column prop="biddingStartTime" label="竞价开始时间">
      </el-table-column>
      <el-table-column prop="biddingEndTime" label="竞价结束时间">
      </el-table-column>
      <el-table-column label="审核状态" width="200px">
        <template slot-scope="scope">
          <span v-if="scope.row.dataStatus==0">未审核</span>
          <span v-if="scope.row.dataStatus==1">审核通过</span>
        </template>
        </el-table-column>


        <el-table-column fixed="right" label="操作" width="200px">
          <template slot-scope="scope">
            <el-button type="success" size="small" @click="jumpTransfer(scope.row.id)" >查看详情
            </el-button>
<!--&&scope.row.biddingEndTime==null-->
            <el-button type="danger"  v-if="scope.row.state==5&&scope.row.dataStatus==1"  @click="jump(scope.row)"  size="small" >
              开始报价
            </el-button>
          </template>
        </el-table-column>

      </el-table>

   <!--   <div style="width:24%;height:250px;" v-for="(item,index) in DataList">
        <div style="width:50%;height:240px;">{{item}}
          <img src="">
        </div>

      </div>
 -->




      <div class="tabListPage">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
          :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        unitCode: "410800000000",//焦作 410800000000
        pageNum: 1, // 默认显示第几页
        totalCount: 1, // 总条数，根据接口获取数据长度(注意：这里不能为空)
        pageSizes: [5, 10, 15, 20], // 个数选择器（可修改）
        pageSize: 10, // 默认每页显示的条数（可修改）
        DataList: [],
        countys:[],
        towns:[],
        villages:[],
        countyCode:"",
        townCode:"",
        villageCode:"",
        type:"",


      }
    },
    created() {
      this.getData()
    },
    destroyed() {
    },
    methods: {
jumpTransfer(ids){
    this.$router.push("/");
     this.$router.push({
           name: 'transferDetail',
           query: {
             id: ids
           }
         })
    },
     async jump(row) {
        localStorage.setItem("projectId",row.id);
        const {
          data: res
        } = await this.$http.get('/web/v1/signUpNum/'+row.id);
        // if(res.data<2){
        //     this.$message.error("该项目审核通过人数为"+res.data+",不符合竞价条件。");
        //     return;
        // }

        if(row.tradeWay==1){
           this.$router.push("/forwardBidding");
           }
     
          if(row.tradeWay==2){
            if(row.projectType==11){
              this.$router.push("/ladderBiddingDown");
            }
            else{
              this.$router.push("/ladderBidding");

            }
             }
      },
      async getData() {
        var num = this.pageNum;
        this.DataList = [];
        // if (this.pageNum != 0) {
        //   num = this.pageNum - 1;
        // }
        const {
          data: res
        } = await this.$http.get('/web/v1/alreadySignItemList?pageNum=' + num + "&pageSize=" + this
          .pageSize );
         this.DataList = res.data.list;
       this.totalCount = res.data.total;
        // for(var i=0;i<res.data.list.length;i++){
        //   if(res.data.list[i].dataStatus==1){
        //    this.DataList.push(res.data.list[i]);
        //    }
        // }
        //   this.totalCount =   this.DataList.length;
        console.log(res);
      },

      // 每页显示的条数，选择每页条数的时候执行
      handleSizeChange(val) {
        this.pageSize = val // 改变每页显示的条数
        this.getData();
        this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
      },
      // 显示第几页
      handleCurrentChange(val) {
        console.log("handleCurrentChange")
        this.pageNum = val; // 改变默认的页数
        this.getData();
      },

    },


  }
</script>

<style lang="scss" scoped="">
  .select {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .selectAdd {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .lable {
    width: 83px;
    color: black;
    font-size: 15px;
    float: left;
    line-height: 40px;
    text-align: right;
  }

  .inp {
    width: 48%;
    height: 32px;
    border: 1px solid #ccc;

  }



  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
